<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" lg="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <spinner v-if="activateSpinner"></spinner>
        <email-address-form :mode="mode" :readonly="!isEditable" v-model="config" v-else></email-address-form>
        <b-row class="justify-content-end">
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('details')">
              <span>{{ $t('common.cncl') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('edit')">
              <i class="fa-light fa-pencil"></i>
              <span>{{ $t('administration.edit') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="deleteEmailAddress">
              <i class="fa-light fa-trash"></i>
              <span>{{ $t('rights.delete') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="editEmailAddress">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="mode === 'add'">
            <b-button variant="primary"
              @click="addEmailAddress">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import EmailAddressForm from '@/pages/email/EmailAddressForm.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: "EmailAddressDetails",
  components: {
    'back-button': backButton,
    'email-address-form': EmailAddressForm,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    pageTitle() {
      switch (this.mode) {
        case 'edit':
          return this.$t('Webheader.email_address_edit');
        case 'details':
          return this.$t('Webheader.email_address_details');
        case 'add':
        default:
          return this.$t('Webheader.email_address_add');
      }
    }
  },
  data() {
    return {
      activateSpinner: false,
      email: '',
      returnUrl: '',
      currentEmailAddress: {},
      savedConfig: [],
      config: {},
      originalConfig: {},
      formType: 'add'
    }
  },
  created() {
    this.activateSpinner = true
    this.formType = this.mode

    this.emailGroupId = this.$route.query.groupId
    this.returnUrl = 'email/emailAddress/' + this.emailGroupId

    if(this.id !== '-1' && (this.mode === "details" || "edit")) {
      this.getEmailAddress()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    addEmailAddress () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        Name: this.config.Name,
        Email: this.config.Email,
        IdEmailGroup: this.emailGroupId,
        id: this.id
      }
      this.$engine.firstOn().email.emailAddress.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.email.email_address_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: 'email/emailAddress/' + that.emailGroupId})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.email.email_address_addition_error'))
      })
    },
    deleteEmailAddress () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.email.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdEmailAddress: that.id
              }
              that.$engine.firstOn().email.emailAddress.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.email.email_address_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, {url: 'email/emailAddress/' + that.emailGroupId })
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.email.email_address_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editEmailAddress () {
      let that = this
      let params = {
        Name: this.config.Name,
        Email: this.config.Email,
        IdEmailGroup: this.emailGroupId,
        IdEmailAddress: this.id
      }
      this.$engine.firstOn().email.emailAddress.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.email.email_address_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: 'email/emailAddress/' + that.emailGroupId })
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.email.email_address_edition_error'))
      })
    },
    fillFields () {
      this.config = this.currentEmailAddress
      this.originalConfig = this.currentEmailAddress
      this.activateSpinner = false
    },
    formHasError () {
      if (this.config.Name === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.email.email_address_name_missing'))
        return true
      }
      if (this.config.Email === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.email.email_address_missing'))
        return true
      }
      return false
    },
    getEmailAddress () {
      let that = this
      this.$engine.firstOn().email.emailAddress.fetch({id: this.id})
      .then(resp => {
        let emailAddressList = {}

        emailAddressList = resp.data.EmailAddress
        that.updateEmailAddress(emailAddressList)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      if (mode === 'details' && this.formType === 'edit') {
        this.config = this.originalConfig
      }
      this.formType = mode
    },
    updateEmailAddress (emailAddressList) {
      const selectedEmail = emailAddressList.find(email => email.IdEmailAddress === this.id)
      this.currentEmailAddress = selectedEmail
      this.fillFields()
    }
  }
}
</script>
